import React from 'react';
import { motion } from 'framer-motion';
import { Trophy } from 'lucide-react';
export function Results() {
  const results = ['Entrás a sesión con más claridad.', 'Diseñás sesiones con foco y dirección.', 'Preparás al deportista para competir con más recursos.', 'Trabajás con más seguridad, orden y autoridad profesional.'];
  return <section className="bg-emerald-50 py-20 lg:py-28" data-id="element-151">
      <div className="container mx-auto px-4 sm:px-6 lg:px-8" data-id="element-152">
        <div className="mx-auto max-w-4xl text-center mb-12" data-id="element-153">
          <div className="mb-6 inline-flex h-16 w-16 items-center justify-center rounded-full bg-emerald-100 text-emerald-600" data-id="element-154">
            <Trophy className="h-8 w-8" data-id="element-155" />
          </div>
          <h2 className="text-3xl text-slate-900 md:text-4xl lg:text-5xl font-display" data-id="element-156">
            EL RESULTADO
          </h2>
        </div>

        <div className="mx-auto max-w-3xl bg-white rounded-3xl p-8 md:p-12 shadow-xl border border-emerald-100" data-id="element-157">
          <ul className="space-y-6" data-id="element-158">
            {results.map((result, idx) => <motion.li key={idx} initial={{
            opacity: 0,
            y: 10
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            delay: idx * 0.05
          }} className="flex items-center gap-4 text-lg text-slate-700 font-medium" data-id="element-159">
                <div className="h-2 w-2 rounded-full bg-emerald-500 shrink-0" data-id="element-160" />
                {result}
              </motion.li>)}
          </ul>
        </div>
      </div>
    </section>;
}